export const getTTL = (endDateTime) => {
  return (
    (new Date(endDateTime).getTime() - Date.now()) / 60000 -
    new Date().getTimezoneOffset() -
    // Subtract 1 second to account for latency
    1
  );
};
